import {TableValueType} from "../../shared";
import {Adjunto, AdjuntoTableColumn, AdjuntoTableRowSource} from "../models";
import { Rol} from "../../core";
import {AdjuntoTableAction} from "../enums";

export const ADJUNTO_CORE_TIPOS = {
  informeSuelo: {id: 'Informe-Suelo', name: 'Informe Suelo'},
  general: {id: 'General', name: 'General'},
  informeTerraza: {id: 'Informe-Terraza', name: 'Informe Terraza'},
  kmlTerraza: {id: 'KML-Terraza', name: 'KML Terraza'},
  informePadron: {id: 'Informe-Padron', name: 'Informe Padrón'},
  efluentesMemoria: {id: 'Efluentes-Memoria-Descriptiva', name: 'Efluentes Memoria Descriptiva'},
  efluentesDocumento: {id: 'Efluentes-Documentos-Salas', name: 'Efluente Documentos Salas entre 300 y 500 VO'},
  analisisSuelo: {id: 'AnalisisSuelo', name: 'Análisis Suelo'},
  analisisSueloBrayI: {id: 'AnalisisSueloBrayI', name: 'Análisis Suelo Bray I'},
  vinculacionJuridica: {id: 'VinculacionJuridica', name: 'Vinculación Jurídica'},
  informePusa: {id: 'InformePusa', name: 'Informe Pusa'},
  informeAuditoria: {id: 'InformeAuditoria', name: 'Informe Auditoria'},
  actaJuntaRiego: {id: 'ActaJuntaRiego', name: 'Acta de Junta de Riego'}
};

export const ADJUNTO_TABLE_COLUMNS_DEFAULT: AdjuntoTableColumn[] = [
  // {
  //   type: TableValueType.LITERAL,
  //   name: 'adjuntoFechaCreacion',
  //   label: 'Fecha',
  //   sort: true,
  //   filter: true,
  //   literalFormat: v => formatDate(v)
  // },
  {
    type: TableValueType.LITERAL,
    name: 'adjuntoNombre',
    label: 'Archivo',
    sort: true,
    filter: true,
    literalFormat: (v, adjunto: Adjunto) => {
      return `${v}.${adjunto.adjuntoExtension}`;
    }
  },
  {
    type: TableValueType.LITERAL,
    name: 'adjuntoComentario',
    label: 'Comentario',
    sort: true,
    filter: true
  },
  // {
  //   type: TableValueType.LITERAL,
  //   name: 'adjuntoExtension',
  //   label: 'Extensión',
  //   sort: false,
  //   filter: true
  // },
  {
    type: TableValueType.LITERAL,
    name: 'adjuntoTipo',
    label: 'Tipo',
    sort: true,
    filter: true,
    literalFormat: v => {
      const val = Object.values(ADJUNTO_CORE_TIPOS).find(at => at.id === v);
      if (val){
        v = val.name;
      }
      return v;
    }
  },
  {
    type: TableValueType.ACTION,
    name: AdjuntoTableAction.ABRIR,
    label: '',
    sort: false,
    filter: false,
    actionFormat: _ => ({
      value: AdjuntoTableAction.ABRIR,
      text: 'Descargar',
      icon: 'file-download'
    })
  },
   {
     type: TableValueType.ACTION,
     name: AdjuntoTableAction.ELIMINAR,
     label: '',
     sort: false,
     filter: false,
     actionFormat: (adjunto: Adjunto, sources: AdjuntoTableRowSource) => {
       if (sources && (
         sources.rolId === Rol.USUARIO_LIBRE ||
         sources.rolId === Rol.ASEGURADORA
       )){
         return {
           value: AdjuntoTableAction.ELIMINAR,
           text: 'Eliminar Adjunto',
           icon: 'trash'
         };
       }
       return null;
     }
   },
];
